import React from "react";
import { Route, Link, Switch, withRouter } from "react-router-dom";

import NeurospherePage from "../../pages/NeurospherePage";
import LabMembersPage from "../../pages/LabMembersPage";
import PublicationsPage from "../../pages/PublicationsPage";

const LinkedText = (props) => {
  let text = props.linkAnchors.map((anchor, index) => {
    const path = `/${props.links[index]}`;
    return (
      <span key={anchor}>
        {props.beforeContent[index]}
        {
          props.links[index].includes("http") ? (
            <a
              className="b-link"
              href={props.links[index]}
              target="_blank"
              rel="noopener noreferrer"
            >
              {anchor}
            </a>
          ) : (
              <Link className="b-link" key={index} to={path}>
                {anchor}
              </Link>
            )
        }
        {props.afterContent[index]}
      </span>
    );
  });
  return (
    <div>
      <p>{text}</p>
      <Switch>
        <Route path="/neurosphere" exact render={() => <NeurospherePage />} />
        <Route path="/publications" exact render={() => <PublicationsPage />} />
        <Route path="/people" exact render={() => <LabMembersPage />} />
      </Switch>
    </div>
  );
};

export default withRouter(LinkedText);
